import httpClient from "../../../client/httpClient";
import { fetchCountries } from "../locations/locationApi";
import { mergeOrderWithSnapshot } from "../orders/ordersService";
import { fetchShippingFees } from "../shippingFees/shippingFeesApi";

export const fetchAffiliateOrders = async (payload = {}, signal) => {
    const {
        filters = {},
        pagination = { page: 1, pageSize: 10 },
        sorting = { sortBy: "id", sortOrder: "DESC" }
    } = payload;

    const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => {
            if (value === undefined || value === "") return false;
            if (Array.isArray(value) && value.length === 0) return false;
            return true;
        })
    );

    try {
        const res = await httpClient.post(
            "/v1/api/customer-order/all",
            {
                pageNumber: pagination.page,
                pageSize: pagination.pageSize,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder,
                filter: {
                    searchKeyword: cleanedFilters?.searchKeyword ?? ""
                }
            },
            {
                params: cleanedFilters,
                paramsSerializer: (params) => {
                    const usp = new URLSearchParams();
                    Object.entries(params).forEach(([key, value]) => {
                        if (Array.isArray(value)) {
                            value.forEach((v) => usp.append(key, v));
                        } else {
                            usp.append(key, value);
                        }
                    });
                    return usp.toString();
                },
                signal
            }
        );

        const shippingFees = await fetchShippingFees(["01", "02"]);
        const countries = await fetchCountries();

        const rawOrders = res.data.content;
        const parsedOrders = mergeOrderWithSnapshot(rawOrders, countries, shippingFees);

        return {
            ...res.data,
            content: parsedOrders
        };
    } catch (error) {
        console.log("Error on fetching all orders", error);
        return Promise.reject(error);
    }
};

export const claimAffiliateOrder = async (orderId, sellerId) => {
    try {
        const res = await httpClient.put(`/v1/api/customer-order/${orderId}/claim`, { sellerId });
        return res.data;
    } catch (error) {
        console.log("Error on claiming affiliate order", error);
        return Promise.reject(error);
    }
};

export const submitAffiliateOrder = async (payload) => {
    try {
        const res = await httpClient.post("/v1/api/customer-order/affiliate-order", payload, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return res.data;
    } catch (error) {
        console.log("Error on submitting affiliate order", error);
        return Promise.reject(error);
    }
};

export const updateAffiliateOrder = async ({ id, payload }) => {
    try {
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            formData.append(key, value);
        });

        const res = await httpClient.patch(
            `/v1/api/customer-order/affiliate-order/${id}`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );
        return res.data;
    } catch (error) {
        console.log("Error on updating affiliate order", error);
        return Promise.reject(error);
    }
};
